export default {"src":"/_next/static/image/src/assets/icons/filter-icons/dishwasher.799edb6133b617598a37752fa227f855.svg","height":32,"width":32};